import React from "react";
import AchievementDetail from "./AchievementDetail.jsx";
import ImageOrFlag from "../../Common/MatchSideImageOrFlag.jsx";
import Moment from "react-moment";

class LiveUpdate extends React.Component {
  render() {
    let {
      marked,
      matches,
      data,
      loading,
      included,
      smallIcons,
      displaySquareBorder,
    } = this.props;
    if (!matches || loading || !data) return null;
    return (
      <section className="live-update">
        {data.map((update) => {
          let match = matches.find((m) => m.id === Number(update.matchId));
          return (
            <div className="match-live-update" key={update.id}>
              <div className="match-live-update__time">
                <Moment format="YYYY-MM-DD">{`${update.updatedOn}`}</Moment>
                <Moment format="HH:mm:ss">{`${update.updatedOn}`}</Moment>
              </div>
              <div className="match-live-update__title">
                <div className="match-live-update__team">
                  <ImageOrFlag
                    displaySquareBorder={displaySquareBorder}
                    side={match.sideA}
                  />
                  <h3 className="match-live-update__team-name">
                    {match.sideA.name}
                  </h3>
                </div>
                <strong className="match-live-update__total-score">
                  {update.score
                    ? `${update.score.sideA} : ${update.score.sideB}`
                    : ""}
                </strong>
                <div className="match-live-update__team">
                  <ImageOrFlag
                    displaySquareBorder={displaySquareBorder}
                    side={match.sideB}
                  />
                  <h3 className="match-live-update__team-name">
                    {match.sideB.name}
                  </h3>
                </div>
              </div>
              <div className="match-live-update__container">
                <MatchUpdateSide
                  entries={update.entries.filter(
                    (updateEntry) => match.sideA.id === updateEntry.teamId
                  )}
                  achievements={included.achievements}
                  sportsmen={included.sportsmen}
                  team={match.sideA}
                  marked={marked}
                  smallIcons={smallIcons}
                  displaySquareBorder={displaySquareBorder}
                />
                <MatchUpdateSide
                  entries={update.entries.filter(
                    (updateEntry) => match.sideB.id === updateEntry.teamId
                  )}
                  achievements={included.achievements}
                  sportsmen={included.sportsmen}
                  team={match.sideB}
                  marked={marked}
                  smallIcons={smallIcons}
                  displaySquareBorder={displaySquareBorder}
                />
              </div>
            </div>
          );
        })}
      </section>
    );
  }

  componentWillMount() {
    if (this.props.classification) {
      this.props.load(this.props.classification);
    }
  }

  componentWillUpdate(nextProps) {
    if (
      !nextProps.classification ||
      nextProps.classification === this.props.classification
    ) {
      return;
    }
    this.props.load(nextProps.classification);
  }
}

const MatchUpdateSide = ({
  entries,
  marked,
  achievements,
  sportsmen,
  team,
  smallIcons,
  displaySquareBorder,
}) => (
  <div className="match-live-update__side">
    {entries.map((updateEntry, key) => (
      <AchievementDetail
        key={key}
        smallIcons={smallIcons}
        detail={updateEntry}
        achievement={achievements[updateEntry.achievementId]}
        sportsmen={sportsmen[updateEntry.sportsmenId]}
        team={team}
        displaySquareBorder={displaySquareBorder}
        marked={marked.indexOf(updateEntry.sportsmenId) !== -1}
      />
    ))}
  </div>
);

export default LiveUpdate;
